module.exports = "<div ng-if=\"$ctrl.warningMessage\" class=\"onesite-base\" tabindex=\"-1\">\r\n    <div class=\"alert alert--info u-noMargin digitalPayWarningDisplay\" ng-class=\"{'digitalPayWarningDisplay--thin': $ctrl.isThinStyle}\">\r\n        <span class=\"digitalPayWarningDisplay-icon\"/>\r\n        <span class=\"digitalPayWarningDisplay-message\">{{$ctrl.warningMessage}}</span>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/wallet/error/digital-pay-warning-display.component.html
// module id = 898
// module chunks = 1